import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'NoResultLazy',
        path: () => path.join(__dirname, './NoGalleryResults'),
        resolve: () => require.resolveWeak('./NoGalleryResults'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "NoResultLazy" */ './NoGalleryResults')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
